import IMG00 from "../images/art/background/Illustration_sans_titre.png"
import IMG01 from "../images/art/background/IMG_0268.png"
import IMG02 from "../images/art/background/IMG_0269.png"
import IMG03 from "../images/art/background/IMG_0270.png"
import IMG04 from "../images/art/background/IMG_0271.png"
import IMG05 from "../images/art/background/IMG_0272.png"
import IMG06 from "../images/art/background/IMG_0273.png"
import IMG07 from "../images/art/background/IMG_0274.png"
import IMG08 from "../images/art/background/IMG_0275.png"
import IMG09 from "../images/art/background/IMG_0276.png"
import IMG10 from "../images/art/background/IMG_0277.png"
import IMG11 from "../images/art/background/IMG_0278.png"

export default function getBackground(data) {
	if (data.storeCount10)
		return IMG11
	if (data.storeCount9)
		return IMG10
	if (data.storeCount8)
		return IMG09
	if (data.storeCount7)
		return IMG08
	if (data.storeCount6)
		return IMG07
	if (data.storeCount5)
		return IMG06
	if (data.storeCount4)
		return IMG05
	if (data.storeCount3)
		return IMG04
	if (data.storeCount2)
		return IMG03
	if (data.storeCount1)
		return IMG02
	if (data.storeCount0)
		return IMG01
	return IMG00
}